import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import ErrorPage from "commonComponents/errorPage/ErrorPage";
import PageHeader from "designV2/components/PageHeader";
import { Skeleton } from "designV2/components/Skeleton";
import AddAdmin from "./AddAdmin";
import "superAdminViews/users/superPeople.css";

const GET_ADMIN = gql`
  query getAdminByAdmin($id: ID!) {
    getAdminByAdmin(id: $id) {
      _id
      fullName
      phoneNumber
      email
      type
      state
      roles {
        id
        name
      }
      shop {
        _id
        name
      }
    }
  }
`;

const EditAdmin = (props) => {
  const { loading, error, data } = useQuery(GET_ADMIN, {
    variables: { id: props.match.params.id },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div className="page superPeoplePage">
        <main className="main">
          <PageHeader title="Edit admin" />
          <Skeleton height={260} />
          <Skeleton height={180} />
        </main>
      </div>
    );
  }

  if (error || !data || !data.getAdminByAdmin) {
    return <ErrorPage />;
  }

  return <AddAdmin admin={data.getAdminByAdmin} />;
};

export default EditAdmin;
